import { Box, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import IconLoader from '../../../IconLoader';
import { AverageAsymmetryCardData } from './averageAsymmetryCardData';

interface AverageAsymmetryCardProps {
  data?: AverageAsymmetryCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const AverageAsymmetryCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const AverageAsymmetryCard: React.FC<AverageAsymmetryCardProps> = ({
  data,
  onClick,
}: AverageAsymmetryCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('averageAsymmetry.title')}
      iconName="AverageAsymmetry"
      popoverContent={t('averageAsymmetry.popover')}
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('averageAsymmetry.description')}
      </CardDetailTypography>
      <AverageAsymmetryCardMedia>
        <PanelDisplayBox>
          <IconLoader name="DailyParameterCardFeetSymmetry" />
          <Typography sx={{ fontWeight: 'bold', fontSize: 20 }}>
            {data ? data.value : '0'}
            {data ? data.unit : '%'}
          </Typography>
        </PanelDisplayBox>
      </AverageAsymmetryCardMedia>
    </ParameterCard>
  );
};

export default AverageAsymmetryCard;
